import { render, staticRenderFns } from "./MySettings.vue?vue&type=template&id=f9dfb310&scoped=true&"
import script from "./MySettings.vue?vue&type=script&lang=js&"
export * from "./MySettings.vue?vue&type=script&lang=js&"
import style0 from "./MySettings.vue?vue&type=style&index=0&id=f9dfb310&prod&lang=less&scoped=true&"
import style1 from "./MySettings.vue?vue&type=style&index=1&id=f9dfb310&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9dfb310",
  null
  
)

export default component.exports